import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../components/header";
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Container,
  Divider,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Snackbar,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import JobInfo from "../components/jobInfo";
import Applicants from "../components/applicants";
import ShareIcon from "@mui/icons-material/Share";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RecommendedTab from "../components/recommendedTab";
import Shortlisted from "../components/Shortlisted";
import Cookies from "js-cookie";
import DeleteJobDialog from "./DeleteJobDialog";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Createjobdrawer from "../components/createjobdrawer";

// ── SHIMMER ──
const Shimmer = ({
  width = "100%",
  height = "16px",
  borderRadius = "6px",
  sx = {},
}) => (
  <Box
    sx={{
      width,
      height,
      borderRadius,
      background:
        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.4s infinite",
      flexShrink: 0,
      "@keyframes shimmer": {
        "0%": { backgroundPosition: "200% 0" },
        "100%": { backgroundPosition: "-200% 0" },
      },
      ...sx,
    }}
  />
);

// ── HEADER SHIMMER ──
const JobDetailHeaderShimmer = ({ onBack, backbutton, setBackbutton }) => (
  <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", pb: 0, mb: 0 }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
      <Box
        onClick={onBack}
        onMouseEnter={() => setBackbutton(true)}
        onMouseLeave={() => setBackbutton(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          pl: "6px",
          pr: backbutton ? "10px" : "6px",
          height: "26px",
          border: `1px solid ${backbutton ? "#3F95EA" : "#E2E8F0"}`,
          borderRadius: "6px",
          cursor: "pointer",
          backgroundColor: backbutton ? "#3F95EA" : "#fff",
          transition: "all 0.2s ease",
          overflow: "hidden",
        }}
      >
        <ChevronLeftIcon
          sx={{
            fontSize: "18px",
            color: backbutton ? "#fff" : "#64748B",
            transition: "color 0.2s",
          }}
        />
        {backbutton && (
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#fff",
              whiteSpace: "nowrap",
            }}
          >
            Back
          </Typography>
        )}
      </Box>
      <Shimmer width="120px" height="22px" borderRadius="6px" />
    </Box>

    <Box sx={{ height: "1px", background: "rgba(21, 29, 72, 0.12)", mb: 2 }} />

    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
        <Shimmer width="64px" height="64px" borderRadius="10px" />
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Shimmer width="180px" height="22px" borderRadius="6px" />
            <Shimmer width="80px" height="22px" borderRadius="20px" />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Shimmer width="90px" height="14px" borderRadius="4px" />
            <Shimmer width="1px" height="14px" borderRadius="0" />
            <Shimmer width="160px" height="14px" borderRadius="4px" />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}
      >
        <Shimmer width="100px" height="32px" borderRadius="8px" />
        <Shimmer width="70px" height="34px" borderRadius="8px" />
        <Shimmer width="34px" height="34px" borderRadius="8px" />
        <Shimmer width="34px" height="34px" borderRadius="8px" />
      </Box>
    </Box>

    <Box
      sx={{ mt: 2, borderBottom: "1px solid rgba(21, 29, 72, 0.12)", pb: 1 }}
    >
      <Box sx={{ display: "flex", gap: 3 }}>
        {["80px", "90px", "90px", "160px"].map((w, i) => (
          <Shimmer key={i} width={w} height="14px" borderRadius="4px" />
        ))}
      </Box>
    </Box>
  </Box>
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: "100%" }}
      {...other}
    >
      {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: "none",
  padding: theme.spacing(1),
}));

const jobStatusArray = ["Closed", "Full", "Cancelled", "On Hold", "Active"];

const statusColors = {
  Active: { bg: "#3F95EA", text: "#fff" },
  "On Hold": { bg: "#FFF8E1", text: "#F57F17" },
  Cancelled: { bg: "#FEECEB", text: "#C62828" },
  Full: { bg: "#FFF3E0", text: "#E65100" },
  Closed: { bg: "#FEECEB", text: "#C62828" },
};

const JobDetails = () => {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const JobEditPermission = PermissionStatus["400"];
  const CandidatePermission = PermissionStatus["100"];
  const { id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [link] = useState("https://example.com");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [isEdit, setIsEdit] = useState("");
  const [jobStatus, setJobStatus] = useState(false);
  const anchorRef = useRef(null);
  const [selectedJobStatus, setSelectedJobStatus] = useState(4);
  const InActiveStatus = ["Cancelled", "Closed", "Full"];
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [singleJobStatus, setSingleJobStatus] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [datemodified, setdatemodified] = useState("");
  const [questionrequired, setquestionrequired] = useState("");
  const [editPermission, setEditPermission] = useState(0);
  const [backbutton, setBackbutton] = useState(false);
  const [loadingJobInfo, setLoadingJobInfo] = useState(true);
  const [editJobOpen, setEditJobOpen] = useState(false);
  let url = "/jobeze.com/jobDetail";
  const location = useLocation();
  const onRowClickInJobAssociated = location?.state?.value;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    localStorage.setItem("jobdetailsTab", value.toString());
  }, [value]);

  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  const baseUrl = process.env.REACT_APP_CLIP_BOARD_URL;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(`${baseUrl}/jobDetail/${id}`);
      setSnackbarMessage("Copied");
      setAlertSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => setSnackbarOpen(false), 1500);
    } catch (err) {
      setSnackbarMessage("Failed to copy the link.");
      setAlertSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleChange = (event, newValue) => setValue(newValue);

  const handleMenuItemClick = (event, index) => {
    setSelectedJobStatus(index);
    setSingleJobStatus(event);
    setJobStatus(false);
    axios
      .post(
        `change-job-status`,
        {
          status: event,
          job_id: parseInt(id),
          original_date_modified: datemodified,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleSnackbarOpen("Job Status Changed Successfully");
          setSnackbarServerity("success");
        }
        setTimeout(handleSnackbarClose, 1500);
        setTimeout(() => window.location.reload(), 300);
      })
      .catch((err) => {
        console.error(err);
        handleSnackbarOpen(err.response.data.error);
        setSnackbarServerity("error");
      });
  };

  const handleToggle = () => setJobStatus((prevOpen) => !prevOpen);

  const handleEdit = () => {
    setEditJobOpen(true);
  };

  const handleJobStatusClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setJobStatus(false);
  };

  const [jobinfo, setJoninfo] = useState([]);
  const getToken = useSelector((state) => state.user.token);

  const getJobInfo = useCallback(() => {
    setLoadingJobInfo(true);
    axios
      .get(`job-info/${id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => {
        setdatemodified(response.data.message.jobInfoResult[0].date_modified);
        setquestionrequired(
          response.data.message.jobInfoResult[0].questionnaire_required,
        );
        setJoninfo(response.data.message.jobInfoResult[0]);
        const st = response.data.message.jobInfoResult[0].status;
        setSelectedJobStatus(jobStatusArray.indexOf(st));
        setEditPermission(response.data.message.jobInfoResult[0].can_edit);
      })
      .catch(() => {})
      .finally(() => setLoadingJobInfo(false));
  }, [id]);

  useEffect(() => {
    getJobInfo();
  }, [getJobInfo]);

  useEffect(() => {
    if (onRowClickInJobAssociated === 0) {
      setValue(0);
    }
  }, [onRowClickInJobAssociated]);

  const isRemote = jobinfo?.work_type?.toLowerCase() === "remote";

  // Date display
  const beforeDate = new Date(`${jobinfo?.date_created}`);
  const today = new Date();
  const diffDays = Math.ceil(
    Math.abs(today - beforeDate) / (1000 * 60 * 60 * 24),
  );
  const backenddate = jobinfo?.date_created?.split("T")[0];
  const formattedDate = new Date().toISOString().split("T")[0];
  const displayText =
    formattedDate === backenddate
      ? "Today"
      : `${diffDays} Day${diffDays !== 1 ? "s" : ""} ago`;

  const IsEmployer = useSelector((state) => state.user.isEmployer);
  const role = useSelector((state) => state.user.role);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [Snackbarserverity, setSnackbarServerity] = useState();

  const handleOpenDeleteDialog = () => setOpenDeleteDialog(true);
  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);

  const [searchParams, setSearchParams] = useSearchParams({});

  const handleBack = () => {
    const previousUrl = sessionStorage.getItem("JobpreviousUrl");
    if (previousUrl) {
      const url = new URL(previousUrl, window.location.origin);
      navigate(`${url.pathname}${url.search}`);
      sessionStorage.removeItem("JobpreviousUrl");
    } else {
      navigate(-1);
    }
  };

  const currentStatus = jobStatusArray[selectedJobStatus];
  const statusStyle = statusColors[currentStatus] || {
    bg: "#F1F5F9",
    text: "#64748B",
  };
  const canEdit = JobEditPermission?.edit && editPermission;
  const canDelete = JobEditPermission?.delete && editPermission;

  const jobTypeMap = {
    H: "Hire",
    C: "Contract",
    F: "Freelance",
    C2H: "Contract to Hire",
  };
  const infoBadges = [
    jobinfo?.workmode,
    jobTypeMap[jobinfo?.type?.trim()?.toUpperCase()] ?? jobinfo?.type,
    jobinfo?.min_experience != null && jobinfo?.max_experience != null
      ? `${jobinfo.min_experience} - ${jobinfo.max_experience} Years`
      : jobinfo?.min_experience != null
        ? `${jobinfo.min_experience}+ Years`
        : jobinfo?.max_experience != null
          ? `Upto ${jobinfo.max_experience} Years`
          : (jobinfo?.experience ?? null),
  ].filter(Boolean);

  return (
    <Box className="pageWrapper">
      {loadingJobInfo ? (
        <JobDetailHeaderShimmer
          onBack={handleBack}
          backbutton={backbutton}
          setBackbutton={setBackbutton}
        />
      ) : (
        <Box
          sx={{ backgroundColor: "#fff", borderRadius: "12px", pb: 0, mb: 0 }}
        >
          {/* Row 1: back arrow + title */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box
              onClick={handleBack}
              onMouseEnter={() => setBackbutton(true)}
              onMouseLeave={() => setBackbutton(false)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                pl: "6px",
                pr: backbutton ? "10px" : "6px",
                height: "26px",
                border: `1px solid ${backbutton ? "#3F95EA" : "#E2E8F0"}`,
                borderRadius: "6px",
                cursor: "pointer",
                backgroundColor: backbutton ? "#3F95EA" : "#fff",
                transition: "all 0.2s ease",
                overflow: "hidden",
              }}
            >
              <ChevronLeftIcon
                sx={{
                  fontSize: "18px",
                  color: backbutton ? "#fff" : "#64748B",
                  transition: "color 0.2s",
                }}
              />
              {backbutton && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  }}
                >
                  Back
                </Typography>
              )}
            </Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: 700, color: "#151D48" }}
            >
              Job Details
            </Typography>
          </Box>

          <Box
            sx={{ height: "1px", background: "rgba(21, 29, 72, 0.12)", mb: 2 }}
          />

          {/* Row 2: logo + job info + right actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {/* Left: logo + info */}
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              {/* Logo */}
              <Box
                sx={{
                  width: "64px",
                  height: "64px",
                  flexShrink: 0,
                  border: "1px solid #E2E8F0",
                  borderRadius: "10px",
                  overflow: "hidden",
                  backgroundColor: "#F8FAFC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {jobinfo?.logo ? (
                  <img
                    src={jobinfo?.logo}
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <Typography
                    sx={{ fontSize: "24px", fontWeight: 700, color: "#CBD5E1" }}
                  >
                    {jobinfo?.title?.[0]?.toUpperCase() || "J"}
                  </Typography>
                )}
              </Box>

              {/* Text info */}
              <Box>
                {/* Title + days badge */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 600,
                      color: "rgba(0, 0, 0, 0.87)",
                    }}
                  >
                    {jobinfo?.title || "NA"}
                  </Typography>
                  <Box
                    sx={{
                      px: "12px",
                      py: "6px",
                      borderRadius: "20px",
                      backgroundColor: "#DFEBF8",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#212121",
                    }}
                  >
                    Posted {displayText}
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    mb: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "rgba(0, 0, 0, 0.60)",
                    }}
                  >
                    {jobinfo?.name || "NA"}
                  </Typography>

                  {!isRemote && (jobinfo?.city || jobinfo?.state) && (
                    <>
                      <Box
                        sx={{
                          width: "1px",
                          height: "14px",
                          backgroundColor: "#9EB6CC",
                        }}
                      />
                      <LocationOnOutlinedIcon
                        sx={{ fontSize: "16px", color: "#000" }}
                      />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "rgba(0, 0, 0, 0.60)",
                        }}
                      >
                        {[jobinfo?.city, jobinfo?.state, "USA"]
                          .filter(Boolean)
                          .join(", ")}
                      </Typography>
                    </>
                  )}
                </Box>

                {/* Info pill badges */}
                <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {infoBadges.map((badge, i) => (
                    <Box
                      key={i}
                      sx={{
                        px: "12px",
                        py: "6px",
                        borderRadius: "20px",
                        backgroundColor: "#F9F9F9",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#212121",
                      }}
                    >
                      {badge}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>

            {/* Right: status + action buttons */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexShrink: 0,
              }}
            >
              {canEdit && (
                <Box sx={{ position: "relative" }}>
                  <Box
                    ref={anchorRef}
                    onClick={handleToggle}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid rgba(0,0,0,0.1)",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        px: "14px",
                        py: "7px",
                        height: "32px",
                        backgroundColor: statusStyle.bg,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 700,
                          color: statusStyle.text,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {currentStatus?.toUpperCase()}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        px: "8px",
                        py: "7px",
                        height: "32px",
                        backgroundColor: statusStyle.bg,
                        borderLeft: `1px solid rgba(255,255,255,0.4)`,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <KeyboardArrowDownIcon
                        sx={{ fontSize: "16px", color: statusStyle.text }}
                      />
                    </Box>
                  </Box>

                  <Popper
                    sx={{ zIndex: 10 }}
                    open={jobStatus}
                    anchorEl={anchorRef.current}
                    transition
                    disablePortal
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom"
                              ? "center top"
                              : "center bottom",
                        }}
                      >
                        <Paper
                          sx={{
                            mt: "4px",
                            borderRadius: "8px",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
                            minWidth: "140px",
                          }}
                        >
                          <ClickAwayListener onClickAway={handleJobStatusClose}>
                            <MenuList autoFocusItem>
                              {jobStatusArray.map((option, index) => (
                                <MenuItem
                                  key={option}
                                  selected={index === selectedJobStatus}
                                  onClick={() =>
                                    handleMenuItemClick(option, index)
                                  }
                                  sx={{ fontSize: "13px" }}
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </Box>
              )}

              {canEdit && (
                <Box
                  onClick={handleEdit}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    px: "10px",
                    height: "34px",
                    border: "1px solid #E2E8F0",
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    "&:hover": { backgroundColor: "#F8FAFC" },
                  }}
                >
                  <img src="/assets/edit.svg" alt="" />
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#3F95EA" }}
                  >
                    Edit
                  </Typography>
                </Box>
              )}

              <Box
                onClick={copyToClipboard}
                sx={{
                  width: "34px",
                  height: "34px",
                  border: "1px solid #E2E8F0",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  "&:hover": { backgroundColor: "#F8FAFC" },
                }}
              >
                <img src="/assets/copy.svg" alt="" />
              </Box>

              {canDelete && (
                <>
                  <Box
                    onClick={handleOpenDeleteDialog}
                    sx={{
                      width: "34px",
                      height: "34px",
                      border: "1px solid #FECACA",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      backgroundColor: "#fff",
                      "&:hover": { backgroundColor: "#FFF5F5" },
                    }}
                  >
                    <img src="/assets/delete.svg" alt="" />
                  </Box>
                  <DeleteJobDialog
                    Deletename={jobinfo.title}
                    id={id}
                    open={openDeleteDialog}
                    handleClose={handleCloseDeleteDialog}
                    setOpenSnackbar={setOpenSnackbar}
                    setSnackbarMessage={setSnackbarMessage}
                    setSnackbarServerity={setSnackbarServerity}
                  />
                </>
              )}
            </Box>
          </Box>

          {/* TABS */}
          <Box sx={{ mt: 2, borderBottom: "1px solid rgba(21, 29, 72, 0.12)" }}>
            <Tabs
              value={value}
              textColor="primary"
              indicatorColor="primary"
              onChange={handleChange}
              aria-label="job details tabs"
              sx={{
                "& .MuiTabs-indicator": { height: "2px", borderRadius: "2px" },
                "& .MuiTab-root": {
                  fontSize: "13px",
                  fontWeight: 500,
                  letterSpacing: "1.25px",
                  minHeight: "40px",
                  padding: "6px 12px",
                },
                minHeight: "40px",
              }}
            >
              <Tab label="Job Info" {...a11yProps(0)} />
              <Tab label="Shortlisted" {...a11yProps(1)} />
              <Tab label="Applicants" {...a11yProps(2)} />
              <Tab
                icon={<img src="/assets/ai_recommendation.svg" alt="" />}
                iconPosition="start"
                label="AI Recommendations"
                sx={{ letterSpacing: "1.25px", px: 2 }}
                {...a11yProps(3)}
              />
            </Tabs>
          </Box>
        </Box>
      )}

      {/* TAB CONTENT */}
      <Box sx={{ height: "100%", overflowY: "hidden" }}>
        <CustomTabPanel value={value} index={0}>
          <JobInfo isDrawerOpen={isDrawerOpen} id={id} />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Shortlisted
            questionrequired={questionrequired}
            status={jobStatusArray[selectedJobStatus]}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Applicants
            status={jobStatusArray[selectedJobStatus]}
            questionrequired={questionrequired}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          className="h-fullllllllllll"
          style={{ height: "100%" }}
        >
          <RecommendedTab
            status={jobStatusArray[selectedJobStatus]}
            id={id}
            className="h-dumpppppppppppppp"
            style={{ height: "100%" }}
          />
        </CustomTabPanel>
      </Box>

      {/* Snackbars */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={Snackbarserverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {editJobOpen && (
        <Createjobdrawer
          open={editJobOpen}
          onClose={() => setEditJobOpen(false)}
          editFlag={1}
          jobId={id}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          setIsSuccess={getJobInfo}
          disableNavigation
        />
      )}
    </Box>
  );
};

export default JobDetails;
